import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import Aos from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import BaseUrl from "../base-api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader/Loader";

const Register = () => {
  const [bankData, setBankData] = useState(null);
  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [errors, setErrors] = useState({});
  const [resendTimer, setResendTimer] = useState(0);
  const [state, setState] = useState([])
  const [district, setDistrict] = useState([])
  const [program, setProgram] = useState([])
  const [alc, setAlc] = useState([])
  const [loading, setLoading] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [paymentStatus, setPaymentStatus] = useState(null);
  const navigate = useNavigate();
  const [retryOtpSent, setRetryOtpSent] = useState(false);
  const [retryOtp, setRetryOtp] = useState("");
  const [statusProgram, setStatusProgram] = useState("");

  const data = async () => {
    setLoading(true)
    try {

      const res = await axios.get(`${BaseUrl}/api/reg/registrationDto`, {
        headers: {
          'Content-Type': "application/json"
        },

      });

      if (res) {

        setState(res.data.state)
        setProgram(res.data.programs)
      }


    } catch (error) {
      console.log(error.response?.data?.message);
    }
    finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.scrollTo(0, 0);
    data();
  }, []);

  const selectDistrict = async (e) => {
    try {
      setLoading(true);
      const res = await axios.get(`${BaseUrl}/api/reg/districts`, {
        params: { stateCode: e.target.value },
        headers: {
          'Content-Type': "application/json"
        },

      });

      if (res) {

        setDistrict(res.data)
      }


    } catch (error) {
      console.log(error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }
  const selectAlc = async (e) => {
    try {
      setLoading(true);
      const res = await axios.get(`${BaseUrl}/api/reg/alcs`, {
        params: { districtCode: e.target.value },
        headers: {
          'Content-Type': "application/json"
        },

      });

      if (res) {


        if (res.data.length == 0) {
          setAlc([{
            "name": "HKCL",
            "code": "295130001"
          }])
        }

        else {
          setAlc(res.data)
        }
      }


    } catch (error) {
      console.log(error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    fname: "",
    dob: "",
    email: "",
    number: "",
    state: "",
    district: "",
    program: "",
    alc: "",
    declaration: false,
  });



  useEffect(() => {
    let timer;
    if (resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else {
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [resendTimer]);

  const handleOTPChange = (e) => {
    let newValue = e.target.value;
    newValue = e.target.value.replace(/\D/g, "");
    if (newValue.length > 6) {
      newValue = newValue.slice(0, 6);
    }

    setOtp(newValue);
  };

  const sendOtp = async () => {
    if (validateForm()) {
      setLoading(true);
      try {
        const data = new FormData();
        data.append("mobileNumber", formData.number)
        const res = await axios.post(`${BaseUrl}/api/notification/sendOtp`, data, {
          headers: {
            'Content-Type': "application/json"
          },

        });
        if (res) {
          toast.success(res.data.message);
          setErrors({});
          setOtpSent(true);
          setResendTimer(120);
          setOtp("");
        }
        else {
          toast.error(res.data?.message);
        }

      } catch (error) {
        toast.error(error.response?.data?.message);
      }
      finally {
        setLoading(false);
      }
    }
  };


  const verifyOtp = async () => {

    if (validateForm()) {
      setLoading(true);
      try {
        const data = new FormData();
        data.append("firstName", formData.firstName)
        data.append("lastName", formData.lastName)
        data.append("fatherName", formData.fname)
        data.append("dob", formData.dob)
        data.append("email", formData.email)
        data.append("mobileNumber", formData.number)
        data.append("stateCode", formData.state)
        data.append("districtCode", formData.district)
        data.append("programCode", formData.program)
        data.append("alcCode", formData.alc)
        data.append("otp", otp)
        const res = await axios.post(`${BaseUrl}/api/reg/registration`, data, {
          headers: {
            'Content-Type': "application/json"
          },

        });
        if (res) {
          console.log(res)
          toast.success("Redirecting you to payment screen...");
          setOtpSent(false);
          setFormData({
            name: "",
            fname: "",
            dob: "",
            email: "",
            number: "",
            state: "",
            district: "",
            program: "",
            alc: "",
            declaration: false,
          });
          setOtp("");
          setBankData(res.data);
          setTimeout(() => {
            document.forms["payuForm"].submit();
          }, 500);
        }
        else {
          toast.error(res.data?.message);
        }

      } catch (error) {
        toast.error(error.response?.data?.message);
      }
      finally {
        setLoading(false);
      }
    }


  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = value;
    if (name === "name" || name === "fname") {

      newValue = value.replace(/[^A-Za-z\s]/g, "");
    }
    if (name === "number") {

      newValue = value.replace(/\D/g, "");


      if (newValue.length > 10) {
        newValue = newValue.slice(0, 10);
      }
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : newValue,
    }));

    //   if (errors[name]) {
    //     setErrors((prevErrors) => ({
    //       ...prevErrors,
    //       [name]: "",
    //     }));
    //   }
    // validateForm();
  };


  const validateForm = () => {
    let newErrors = {};

    if (!formData.firstName.trim()) newErrors.firstName = "First Name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last Name is required";
    if (!formData.fname.trim()) newErrors.fname = "Father's Name is required";
    if (!formData.dob) newErrors.dob = "Date of Birth is required";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!formData.number.trim()) {
      newErrors.number = "Phone number is required";
    } else if (!/^[6-9][0-9]{9}$/.test(formData.number)) {
      newErrors.number = "Must be 10 digits, starting with 6-9";
    }
    if (!formData.state.trim()) newErrors.state = "State is required";

    if (!formData.district.trim()) newErrors.district = "District is required";

    if (!formData.program.trim()) newErrors.program = "Program selection is required";

    if (!formData.alc.trim()) newErrors.alc = "ALC selection is required";

    if (!formData.declaration) newErrors.declaration = "You must agree to proceed";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const fetchPaymentStatus = async () => {
    setLoadingStatus(true);
    try {
      const url = statusProgram 
        ? `${BaseUrl}/api/pay/check-payment?mobileNumber=${mobileNumber}&program=${statusProgram}`
        : `${BaseUrl}/api/pay/check-payment?mobileNumber=${mobileNumber}`;
      const response = await axios.get(url);
      if (response.data)
        setPaymentStatus(response.data);
      else
        toast.error("Error fetching status.")
    } catch (error) {
      console.log(error)
      toast.error(error.response.data)
    }
    setLoadingStatus(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setPaymentStatus(null);
    if (mobileNumber && mobileNumber.trim()) {
      fetchPaymentStatus();
    }
  };

  const retryPayment = async () => {
    if (paymentStatus !== 'SUCCESS' && paymentStatus !== 'PAID' && paymentStatus !== 'SPLIT' && paymentStatus !== 'INITIATED') {
      if (!retryOtp || retryOtp.length !== 6) {
        toast.error("Please enter a valid 6-digit OTP.");
        return;
      }

      try {
        const res = await axios.post(`${BaseUrl}/api/pay/initiate?mobileNumber=${mobileNumber}&otp=${retryOtp}&program=${retryOtp}`, {
          headers: {
            'Content-Type': "application/json"
          }
        });

        if (res.data) {
          toast.success("Redirecting you to payment screen...");
          setBankData(res.data);
          setTimeout(() => {
            document.forms["payuForm"].submit();
          }, 500);
        } else {
          toast.error(res.data?.message || "Payment initiation failed.");
        }

      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data?.message || "Error during retry.");
      }
    }
  };

  return (
    <>
      {loading ? (
        <div style={{ marginBottom: "15vh" }}>
          <Loader />
        </div>
      ) : (
        <section className="home-section">
          <Container className="py-3 " data-aos="fade-up">
            <div className="row container mt-1 justify-content-center">
              <div className="col-10 bg-white shadow-lg p-3">
                <div style={{ position: "relative", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <h3 className="text-uppercase text-warning" style={{ fontWeight: "500", margin: 0 }}>
                 
                    <span style={{ color: "#b38000" }}>Register Now.</span>
                  </h3>
                  <span
                    style={{ position: "absolute", right: 0, cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => setShowModal(true)}
                  >
                    Already Registered?
                  </span>
                </div>

                <hr style={{ color: "#ffc107" }} />

                <div className="row">
                  <div className="col-md-6 form-group my-3">
                    <label className="mb-2">First Name:<span style={{ color: "red" }}>*</span></label>
                    <input
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter First Name"
                      disabled={otpSent}
                    />
                    {errors.firstName && <span className="text-danger">{errors.firstName}</span>}
                  </div>
                  <div className="col-md-6 form-group my-3">
                    <label className="mb-2">Last Name:<span style={{ color: "red" }}>*</span></label>
                    <input
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter Last Name"
                      disabled={otpSent}
                    />
                    {errors.lastName && <span className="text-danger">{errors.lastName}</span>}
                  </div>

                  <div className="col-md-6 form-group my-3">
                    <label className="mb-2">Father’s Name:<span style={{ color: "red" }}>*</span></label>
                    <input
                      name="fname"
                      value={formData.fname}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter Father's Name"
                      disabled={otpSent}
                    />
                    {errors.fname && <span className="text-danger">{errors.fname}</span>}
                  </div>

                  <div className="col-md-6 form-group my-3">
                    <label className="mb-2">Date of Birth:<span style={{ color: "red" }}>*</span></label>
                    <input
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleChange}
                      className="form-control"
                      disabled={otpSent}
                      onKeyDown={(e) => e.preventDefault()}
                      max={new Date(new Date().setFullYear(new Date().getFullYear() - 14))
                        .toISOString()
                        .split("T")[0]}
                    />
                    {errors.dob && <span className="text-danger">{errors.dob}</span>}
                  </div>

                  <div className="col-md-6 form-group my-3">
                    <label className="mb-2">Email Address:<span style={{ color: "red" }}>*</span></label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter Email Address"
                      disabled={otpSent}
                    />
                    {errors.email && <span className="text-danger">{errors.email}</span>}
                  </div>

                  <div className="col-md-6 form-group my-3">
                    <label className="mb-2">Phone Number:<span style={{ color: "red" }}>*</span></label>
                    <input
                      type="tel"
                      name="number"
                      value={formData.number}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter Contact Number"
                      disabled={otpSent}
                    />
                    {errors.number && <span className="text-danger">{errors.number}</span>}
                  </div>
                  <div className="col-md-6 form-group my-3">
                    <label className="mb-2">State:<span style={{ color: "red" }}>*</span></label>
                    <select className="form-control" name="state" value={formData.state} disabled={otpSent} onChange={(e) => { handleChange(e); selectDistrict(e) }}>
                      <option value={""}>Select State...</option>
                      {state?.map((item, index) => (
                        <option key={index} value={item.code} >{item.name}</option>

                      ))}

                    </select>
                    {errors.state && <span className="text-danger">{errors.state}</span>}
                  </div>
                  <div className="col-md-6 form-group my-3">
                    <label className="mb-2">District:<span style={{ color: "red" }}>*</span></label>
                    <select className="form-control" name="district" value={formData.district} disabled={otpSent} onChange={(e) => { handleChange(e); selectAlc(e) }}>
                      <option value={""}>Select District...</option>
                      {district?.map((item, index) => (
                        <option key={index} value={item.code} >{item.name}</option>

                      ))}
                    </select>
                    {errors.district && <span className="text-danger">{errors.district}</span>}
                  </div>
                  <div className="col-md-6 form-group my-3">
                    <label className="mb-2">Program with Selected Duration:<span style={{ color: "red" }}>*</span></label>
                    <select className="form-control" name="program" value={formData.program} disabled={otpSent} onChange={handleChange}>
                      <option value={""}>Select Program...</option>
                      {program?.map((item, index) => (
                        <option key={index} value={item.code} >{item.name}</option>

                      ))}
                    </select>
                    {errors.program && <span className="text-danger">{errors.program}</span>}
                  </div>
                  <div className="col-md-6 form-group my-3">
                    <label className="mb-2">Authorized Learning Centre: <span style={{ color: "red" }}>*</span></label>
                    <select className="form-control" name="alc" value={formData.alc} disabled={otpSent} onChange={handleChange}>
                      <option value={""}>Select ALC...</option>
                      {alc?.map((item, index) => (
                        <option key={index} value={item.code} >{item.name}</option>

                      ))}
                    </select>
                    {errors.alc && <span className="text-danger">{errors.alc}</span>}
                  </div>
                </div>

                <div className="mt-4" style={{ textAlign: "justify" }}>
                  <div className=" d-flex align-items-start ">
                    <input className="mt-1 me-2"
                      type="checkbox"
                      name="declaration"
                      checked={formData.declaration}
                      onChange={handleChange} z
                      disabled={otpSent}
                    />{" "}
                    I declare that the information provided in this form is accurate and complete to
                    the best of my knowledge. I acknowledge that the selected program and duration are final and cannot be
                    changed once the registration is confirmed. I agree to pay the applicable fee for the selected program and
                    understand that the fee is non-refundable under any circumstances. I give my consent to the collection and
                    storage of my entered personal information in accordance with HKCL's privacy policy. Furthermore, I accept
                    that HKCL reserves the right to amend program schedules or content as necessary.

                  </div>
                  {errors.declaration && <span className="text-danger ms-4">{errors.declaration}</span>}
                </div>

                <div className="row justify-content-center">
                  {otpSent ? (
                    <>
                      <div className="col-md-4 form-group my-3">
                        <label className="mb-2">OTP:</label>
                        <input type="tel" name="otp" value={otp} onChange={handleOTPChange} className="form-control" placeholder="Enter OTP" />
                        {errors.otp && <span className="text-danger">{errors.otp}</span>}
                      </div>
                      <div className="col-md-5 form-group my-3 pt-2">
                        <div className="text-center mt-4">
                          <button className="btn btn-success mx-2" onClick={verifyOtp} disabled={otp.length == 0}>Proceed to Pay</button>
                          <button className="btn btn-danger mx-2" onClick={sendOtp} disabled={resendTimer > 0}>{resendTimer > 0 ? `Resend in ${resendTimer}s` : "Resend OTP"}</button>
                        </div>
                      </div>
                    </>
                  )
                    : (
                      <div className="text-center mt-3">
                        <button className="btn btn-success" onClick={sendOtp} >Send OTP</button>
                      </div>
                    )}

                </div>

              </div>
            </div>
            {bankData && (
              <form
                name="payuForm"
                action={bankData?.action}
                method="post"
                style={{ display: "none" }}
              >
                {Object.entries(bankData).map(
                  ([key, value]) =>
                    key !== "action" && (
                      <input key={key} type="hidden" name={key} value={value} />
                    )
                )}
              </form>
            )}

          </Container>
        </section>
      )}
      {showModal && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
          background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000
        }}>
          <div style={{ background: "#fff", padding: 20, borderRadius: 8, minWidth: 300 }}>
            <h4 className="text-uppercase">Check Payment Status</h4>
            <form onSubmit={handleSubmit}>
              <select
                value={statusProgram}
                onChange={(e) => setStatusProgram(e.target.value)}
                style={{ width: "100%", padding: "8px", margin: "10px 0" }}
              >
                <option value="">All Programs</option>
                {program?.map((item, index) => (
                  <option key={index} value={item.code}>{item.name}</option>
                ))}
              </select>
              <input
                type="text"
                placeholder="Enter Mobile Number"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
                style={{ width: "100%", padding: "8px", margin: "10px 0" }}
              />
              <button type="submit" style={{ padding: "8px 16px" }}>
                {loadingStatus ? "Checking..." : "Submit"}
              </button>
              <button type="button" className="btn btn-danger" onClick={() => { setShowModal(false); setPaymentStatus(null); setMobileNumber(null); setStatusProgram("") }} style={{ marginLeft: 10 }}>
                Close
              </button>
            </form>
            {paymentStatus && (
              <div style={{ marginTop: 10 }}>
                <strong>Status:</strong> {paymentStatus}
                {paymentStatus !== 'SUCCESS' && paymentStatus !== 'PAID' && paymentStatus !== 'SPLIT' && paymentStatus !== 'INITIATED' && (
                  <div className="mt-3">

                    {!retryOtpSent ? (
                      <button className="btn btn-info me-2 text-white" onClick={async () => {
                        try {
                          const res = await axios.post(`${BaseUrl}/api/notification/sendOtp`, { mobileNumber }, {
                            headers: { 'Content-Type': 'application/json' }
                          });
                          if (res.data?.message) {
                            toast.success("OTP sent successfully!");
                            setRetryOtpSent(true);
                          }
                        } catch (error) {
                          toast.error(error.response?.data?.message || "Failed to send OTP.");
                        }
                      }}>
                        Retry Payment?
                      </button>
                    ) : (
                      <>
                        <input
                          type="text"
                          maxLength={6}
                          placeholder="Enter OTP"
                          className="form-control d-inline-block w-auto me-2"
                          value={retryOtp}
                          onChange={(e) => setRetryOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                        />

                        <button className="btn btn-success" onClick={retryPayment}>
                          Proceed to Pay
                        </button>
                      </>
                    )}

                  </div>
                )}
              </div>

            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Register;
